module.exports = __webpack_public_path__ + "static/img/2.b2d4fce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/2.jpg
// module id = +4vT
// module chunks = 1